import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  makeStyles,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@material-ui/core";

import Note from "../../UI/Note";
import { ModalObservaciones } from "./ModalObservaciones";

import {
  getObservacionesPorSolicitud,
  getTiposObservaciones,
} from "../../../../actions/autorizaciones/Autorizaciones";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const useStyles = makeStyles({
  hoverObservaciones: {
    backgroundColor: "#8080800f",
    "&:hover": {
      backgroundColor: "#80808026",
      cursor: "pointer",
    },
  },
});

export const ObservacionesMenu = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    observaciones = [],
    solicitudSeleccionada = {},
    // tiposObservaciones = [],
  } = useSelector((state) => state.autorizaciones);

  const [openModal, setOpenModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("");
  const [editObservacion, setEditObservacion] = useState(null);

  let idSolicitud = null;

  if (solicitudSeleccionada) {
    idSolicitud = solicitudSeleccionada?.idSolicitud;
  }

  useEffect(() => {
    dispatch(getTiposObservaciones(props.disabled));
    dispatch(getObservacionesPorSolicitud(idSolicitud));
  }, []);
  console.log(observaciones)
  return (
    <React.Fragment>
      {openModal && (
        <ModalObservaciones
          open={openModal}
          close={() => {
            setOpenModal(false);
          }}
          desdeIngresoSolicitud={props.desdeIngresoSolicitud}
          titulo={tituloModal}
          disabled={props.disabled}
          idSolicitud={idSolicitud}
          observacion={editObservacion}
          filtros={props.filtros}
          cierreInternacion={false}
        />
      )}
      <div style={{ textAlign: "center", margin: "1rem 0" }}>
        <Button
          disabled={props.disabled}
          variant="contained"
          color="primary"
          onClick={() => {
            setTituloModal("Agregar Observación");
            setEditObservacion(null);
            setOpenModal(true);
          }}
        >
          + Agregar observación
        </Button>
      </div>
      {Array.isArray(observaciones) && observaciones?.length > 0 ? (
        <List>
          {observaciones.map((observacion) => (
            <ListItem
              key={observacion.idObservacion.toString()}
              className={classes.hoverObservaciones}
              onClick={() => {
                setTituloModal("Editar Observación");
                setEditObservacion(observacion);
                setOpenModal(true);
              }}
            >
              <ListItemAvatar>
                <Note
                />
              </ListItemAvatar>
                <ListItemText
                  primary={
                  `${observacion.tipoObservacion.observacion1} - ${observacion.usuarios.userName}`
                  }
                  secondary={new Date(observacion.fecha).toLocaleString(
                    "es",
                    optionsfecha
                  ) 
                }
                
                />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography
          style={{
            fontSize: "1.1rem",
            fontStyle: "italic",
            marginBottom: "1rem",
          }}
        >
          No hay observaciones
        </Typography>
      )}
    </React.Fragment>
  );
};
